// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3QB_7","ranges":"BmiRanges_ranges__32fKo"};